import Button from '@mui/material/Button';
import { Badge } from '@mui/material';
import React from 'react';

export function CustomBadge({ children, ...props }: any) {
    return <Badge {...props}>{children}</Badge>;
}
